import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function MyProfileAddressSkeleton() {
  return (
    <div className="card-body order-address-body p-4 rounded shadow-sm">
      <div className="row">
        <div className="col-lg-12">
          <div className="addressDetails">
            <address className="text-dark mb-3">
              {/* Name (bold) */}
              <div style={{ display: "inline-block", marginBottom: 8 }}>
                <Skeleton height={20} width={180} />
              </div>

              {/* 4 lines of address */}
              <div style={{ marginTop: 6 }}>
                <Skeleton height={14} width={`70%`} />
                <Skeleton height={14} width={`60%`} style={{ marginTop: 6 }} />
                <Skeleton height={14} width={`65%`} style={{ marginTop: 6 }} />
                <Skeleton height={14} width={`50%`} style={{ marginTop: 6 }} />
              </div>
            </address>

            <div className="addressDetails-contact mt-3">
              <p style={{ margin: 0 }}>
                <b
                  style={{
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginRight: 8,
                  }}
                >
                  <Skeleton height={14} width={110} />
                </b>
                <span
                  style={{ display: "inline-block", verticalAlign: "middle" }}
                >
                  <Skeleton height={14} width={120} />
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
